/**
 * Defines actions related to notifications feature.
 */

import * as types from '../../constants/ActionTypes';

export const getMessages = (payload) => ({
  type: types.NOTIFICATIONS_GET_MSGS,
  payload,
});

export const getMsgsSuccess = (payload) => ({
  type: types.NOTIFICATIONS_GET_MSGS_SUCCESS,
  payload,
});

export const markMsgArchive = (payload) => ({
  type: types.NOTIFICATIONS_MARK_ARCHIVE,
  payload,
});

export const markMsgArchiveSuccess = (payload) => ({
  type: types.NOTIFICATIONS_MARK_ARCHIVE_SUCCESS,
  payload,
});
